import React from 'react'
import PropTypes from 'prop-types'
import { Rows } from '@paper-monster/web/src/components/layout'
import { Link, Text } from '@paper-monster/web/src/components/common'

import routes from '@/routes'

import styles from './Footer.module.scss'

// Plain links: the footer marks no active page. `openTab` is what puts an
// external link in a new tab.
export default function FooterNavList({ navItems, titleMessageId }) {
  return (
    <Rows gap={8}>
      <Text.H4
        bold
        className={styles.listHeader}
        messageId={titleMessageId}
        onTint
        size="small"
        type="body"
      />
      {navItems.map((item) => (
        <Link
          key={item.name}
          className={styles.navLink}
          external={item.external}
          messageId={`navLinks.${item.name}`}
          openTab={item.openTab}
          size="xsmall"
          to={item.to || routes[item.name]}
        />
      ))}
    </Rows>
  )
}

FooterNavList.propTypes = {
  navItems: PropTypes.arrayOf(PropTypes.shape({})),
  titleMessageId: PropTypes.string,
}
